/* eslint-disable */
import {extendDecorator} from '@/js/common/Domain/Service/mixins/decorators';
import commentTemplate from './review.html';

@extendDecorator({
    events: {
        'click .reviewReadMore': 'toggleFullDescription',
        'click .reviewReadLess': 'toggleFullDescription',
    },
    el: '<div itemprop="review" itemscope itemtype="http://schema.org/Review" class="hotelReview"></div>',
    template: commentTemplate,
})
export default class OurReview extends Backbone.Epoxy.View {
    initialize() {
        this.render();
    }

    render() {
        const model = this.model.toJSON({ computed: true });
        this.$el.html(this.template(model));
    }

    toggleFullDescription(e) {
        const $container = $(e.currentTarget).parent();
        $container.find('.hotelReviewFullText').toggle();
        $container.find('.hotelReviewText').toggle();
        $container.find('.reviewReadMore, .reviewReadLess').toggleClass('show');
    }

}